<template>
    <div class="p-3 row justify-content-center">
        <ElForm :disabled="saving" v-if="event" :model="event" label-position="top" :rules="rules" ref="formRef">
            <ElFormItem label="Nome do evento" prop="name">
                <ElInput name="name" v-model="event.name" />
            </ElFormItem>
            <ElFormItem label="Imagem promocional" prop="image">
                <img style="max-height: 250px; max-width: 100%;" :src="(event.image as string)" />
                <input type="file" name="image" @change="changeFile" />
            </ElFormItem>
            <ElFormItem label="Tipo do evento" prop="type">
                <ElInput name="type" v-model="event.type" />
            </ElFormItem>
            <ElFormItem label="Data e hora" prop="event_time">
                <ElDatePicker type="datetime" format="DD/MM/YYYY HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" name="event_time" :clearable="false" v-model="event.event_time" />
            </ElFormItem>
            <ElFormItem label="Descricao do evento" prop="description">
                <ElInput type="textarea" name="description" v-model="event.description" />
            </ElFormItem>
            <ElButton plain type="primary" :disabled="event.price == 0" @click="() => {event.price = 0; event.vip_price = 0}">
                Evento gratis
            </ElButton>
            <span v-if="event.price == 0">Este evento &eacute; grat&iacute;s</span>
            <ElRow>
                <ElCol :sm="12" :md="12">
                    <ElFormItem label="Preço normal" prop="price">
                        <ElInputNumber name="price" v-model="event.price" :step="0.001" :min="0" />
                    </ElFormItem>
                </ElCol>
                <ElCol :sm="12" :md="12">
                    <ElFormItem label="Preço VIP" prop="vip_price">
                        <ElInputNumber name="vip_price" v-model="event.vip_price" :step="0.001" :min="0" />
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow>
                <ElCol :sm="12" :md="12">
                    <ElFormItem label="Nr de lugares normais" prop="places">
                        <ElInputNumber name="places" v-model="event.places" :step="1" :min="0" />
                    </ElFormItem>
                </ElCol>
                <ElCol :sm="12" :md="12">
                    <ElFormItem label="Nr de lugares VIP" prop="vips">
                        <ElInputNumber name="vips" v-model="event.vips" :step="1" :min="0" />
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElFormItem label="Local" prop="area.name" v-if="event.area">
                <ElInput name="area" v-model="event.area.name" />
            </ElFormItem>
            <div style="height: 400px; width: 100%" class="position-relative">
                <el-button plain class="position-absolute end-0" style="z-index: 1024;" :loading="locating || saving" size="large" type="success" @click.prevent="locate">
                    Localizar-me
                </el-button>
                <LMap @contextmenu="onMapClick" ref="map" v-if="event.area" :zoom="16" :center="[event.area.lat, event.area.long]">
                    <LTileLayer
                        url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"
                        layer-type="base"
                        name="OpenStreetMap"
                    ></LTileLayer>

                    <LMarker v-if="event.area" :lat-lng="[event.area.lat, event.area.long]">
                        <LTooltip>{{ event.name }}</LTooltip>
                    </LMarker>
                </LMap>
            </div>
        </ElForm>
        <el-row justify="space-between" class="py-4">
            <el-col class="col-auto">
                <el-button type="primary" @click="submit(formRef)" plain :loading="saving">
                    Salvar e publicar
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script setup lang="ts">
    import Api from '@/services/api';
    import { Event } from '@/services/types';
    import { ElForm, ElDatePicker, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInputNumber, ElInput, ElDivider, ElFormItem, ElButton } from 'element-plus';
    import { reactive, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';
    import { useStore } from 'vuex';

    const router = useRouter()
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const store = useStore()

    const event = reactive<Event>({
        type: '',
        description: '',
        event_time: new Date(),
        image: null,
        name: '',
        places: 0,
        price: 0.01,
        vip_price: 0.01,
        vips: 0,
        area: {lat: 18.34, long: 34.18, name: ''}
    })

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            event.image = URL.createObjectURL(files[0])
        }
    }
    
    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (event.area) {
            event.area.lat = lat
            event.area.long = lng
        } else {
            event.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(event.area);
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (event.area) {
                event.area.lat = position.coords.latitude
                event.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!event.area?.lat || !event.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(event)
                if (image.value) {
                    formData.append("image", image.value)
                }

                const res = await Api.post('/admin/events', event, formData)
                if (res.status == 200) {
                    store.commit('setOpenModal', -1)
                    router.push('/events/' + res.data.event.id)
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>